import { lazy } from "react";
import { Route } from "react-router-dom";

const DarkStoreRequest = lazy(() => import("./pages/DarkStoreRequest.jsx"));
const DarkStoreManagement = lazy(() => import("./pages/DarkStoreManagement.jsx"));
const DarkStoreDashboard = lazy(() => import("./pages/DarkStoreDashboard.jsx"));
const OwnerQueuePage = lazy(() => import("./pages/OwnerQueuePage.jsx"));
const Payouts = lazy(() => import("./pages/Payouts.jsx"));
const InventorySearch = lazy(() => import("./pages/InventorySearch.jsx"));
const RiderRoster = lazy(() => import("./pages/RiderRoster.jsx"));
const OrdersQueue = lazy(() => import("./pages/OrdersQueue.jsx"));
const Dispatches = lazy(() => import("./pages/Dispatches.jsx"));
const Returns = lazy(() => import("./pages/Returns.jsx"));
const RiderAssign = lazy(() => import("./pages/RiderAssign.jsx"));
const SellerSettlements = lazy(() => import("./pages/SellerSettlements.jsx"));

export default function OwnerRoutes() {
  return (
    <>
      <Route path="/dark-store-request" element={<DarkStoreRequest />} />
      <Route path="/dark-store-management" element={<DarkStoreManagement />} />
      <Route path="/dark-store-dashboard" element={<DarkStoreDashboard />} />
      <Route path="/dark-store-dashboard/queues/:queueId" element={<OwnerQueuePage />} />
      <Route path="/payouts" element={<Payouts />} />
      <Route path="/inventory-search" element={<InventorySearch />} />
      <Route path="/riders" element={<RiderRoster />} />
      <Route path="/orders" element={<OrdersQueue />} />
      <Route path="/dispatches" element={<Dispatches />} />
      <Route path="/returns" element={<Returns />} />
      <Route path="/rider-assign" element={<RiderAssign />} />
      <Route path="/seller-settlements" element={<SellerSettlements />} />
    </>
  );
}
